package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.GET_USER_STORED_CARDS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetUserStoredCardsRequestModel(
    val userId: Long
) : BaseRequestModel(api = GET_USER_STORED_CARDS)
